<div class="stars">
    <fa-icon class="stars__star" [icon]="['fas', 'star']" *ngFor="let i of icons"></fa-icon>
</div>
